import $ from "jquery";
import Component from "vue-class-component";
import { EventBus } from "../Controls/EventBus";
import { VueBase } from "../Controls/VueBase";
import { ParametresInstance } from "../Controls/Parameters";
import ModalAjoutSocieteComponent from "./modalAjoutSociete/modalAjoutSociete";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { UtilisateurConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurConnecteDto";

@Component({
	components: {
		AdministratifSocieteComponent: require("./administratif/administratifSociete.vue.html"),
		ParametrageSocieteComponent: require("./parametrage/parametrageSociete.vue.html"),
		ReglementsSocieteComponent: require("./reglements/reglementsSociete.vue.html"),
		DsnSocieteComponent: require("./dsn/dsnSociete.vue.html"),
		ModalAjoutSocieteComponent: require("./modalAjoutSociete/modalAjoutSociete.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as SocieteComponent);

			if (to.query.onglet != undefined) {
				vm.tab = Number(to.query.onglet);
				delete to.query.onglet;
				// La vérification des permissions se fera dans changeTab()
				vm.changeTab(vm.tab);
			}
		});
	}
})
export default class SocieteComponent extends VueBase {
	public tab = 0;
	public currentId = -1;
	public isModified = false;
	public modalAjoutSociete?: ModalAjoutSocieteComponent = undefined;

	// Propriétés pour le contrôle d'accès basé sur les rôles
	public showParametrageTab = true;
	public showReglementsTab = true;
	public showDsnTab = true;

	public mounted(): void {
    	this.initializeRoleBasedAccess();
    	this.changeTab(this.tab);

    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.isModified = false;
    		this.changeTab(this.tab);
    	});
	}

	public changeTab(index: any): void {
    	if (this.isModified) {
   		return;
   		}

    	// Vérifier les permissions d'accès selon les rôles
    	if (index === 1 && !this.showParametrageTab) {
    		index = 0; // Rediriger vers Administratif
    	} else if (index === 2 && !this.showReglementsTab) {
    		index = 0; // Rediriger vers Administratif
    	} else if (index === 3 && !this.showDsnTab) {
    		index = 0; // Rediriger vers Administratif
    	}

    	this.tab = index;

    	const child: any = this.$children[this.tab];
    	child.Init();
	}

	public onCurentTabModifier(isModified: any): void {
    	this.isModified = isModified;
	}

	public ajouter(): void {
    	if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
   		return;
   	}
    	if (this.modalAjoutSociete == undefined) {
   		this.modalAjoutSociete = this.$refs.modalAjoutSociete as ModalAjoutSocieteComponent;
   	}

    	if (this.modalAjoutSociete != undefined) {
   		this.modalAjoutSociete.init();
   	}

    	$("#modalAjoutSociete").modal("show");
	}

	/**
	 * Initialise le contrôle d'accès basé sur les rôles utilisateur
	 */
	private initializeRoleBasedAccess(): void {
		const user: UtilisateurConnecteDto | undefined = ParametresInstance.utilisateurCourant;
		
		if (user && user.Roles) {
			// Si l'utilisateur a le rôle UtilisateurPST, masquer tous les onglets sauf Administratif
			if (user.Roles.includes(RoleConstants.UtilisateurPST) && 
				!user.Roles.includes(RoleConstants.Administrateur) && 
				!user.Roles.includes(RoleConstants.Payeur) && 
				!user.Roles.includes(RoleConstants.AdministrateurPST)) {
				
				this.showParametrageTab = false;
				this.showReglementsTab = false;
				this.showDsnTab = false;
			} else {
				// Pour Administrateur, Payeur, AdministrateurPST : afficher tous les onglets
				this.showParametrageTab = true;
				this.showReglementsTab = true;
				this.showDsnTab = true;
			}
		}
	}
}




// WEBPACK FOOTER //
// ./src/components/ficheSociete/ficheSociete.ts